const palette = {
  common: ['#eaf4ff', '#66738a', '#101828'],
  rare: ['#6aa9ff', '#53ffb5', '#091525'],
  epic: ['#b044ff', '#ff70d7', '#12071d'],
  legendary: ['#ffd166', '#ff4f68', '#1e1205'],
};

const glyphs = {
  moveSpeed: 'M 34 20 L 70 20 L 54 45 L 78 45 L 28 88 L 43 56 L 22 56 Z',
  damage: 'M 52 14 L 61 41 L 90 41 L 66 58 L 75 86 L 52 69 L 29 86 L 38 58 L 14 41 L 43 41 Z',
  fireRate: 'M 50 13 C 68 29 75 43 68 58 C 62 71 47 74 37 64 C 25 52 32 34 50 13 Z M 52 45 C 42 54 42 65 53 72 C 63 64 63 54 52 45 Z',
  bulletSize: 'M 52 14 C 70 28 78 47 70 65 C 61 84 43 89 30 77 C 18 65 24 42 52 14 Z',
  pellets: 'M 28 30 A 12 12 0 1 1 27 30 M 56 20 A 12 12 0 1 1 55 20 M 76 48 A 12 12 0 1 1 75 48 M 42 70 A 12 12 0 1 1 41 70',
  pierce: 'M 18 54 L 82 20 L 58 85 L 52 61 Z',
  ricochet: 'M 23 30 L 62 30 L 50 18 M 62 30 L 50 43 M 78 74 L 38 74 L 50 61 M 38 74 L 50 88 M 25 32 L 76 72',
  orbitals: 'M 52 27 A 25 25 0 1 1 51 27 M 52 38 A 14 14 0 1 1 51 38 M 25 52 A 7 7 0 1 1 24 52 M 79 52 A 7 7 0 1 1 78 52',
  skyLaser: 'M 45 10 L 67 10 L 55 43 L 74 43 L 35 94 L 47 57 L 30 57 Z',
  freezeAura: 'M 52 16 L 52 88 M 25 28 L 79 76 M 79 28 L 25 76 M 39 23 L 52 36 L 65 23 M 39 81 L 52 68 L 65 81',
  chainLightning: 'M 24 22 L 57 22 L 43 47 L 72 47 L 35 86 L 47 58 L 20 58 Z',
  stormCall: 'M 26 40 C 29 24 45 18 58 27 C 70 26 80 35 79 48 C 89 51 91 68 78 75 L 31 75 C 15 72 12 51 26 40 Z M 41 80 L 35 95 M 58 80 L 50 99 M 74 80 L 68 95',
  deathNova: 'M 52 12 L 60 38 L 87 24 L 72 52 L 94 72 L 64 69 L 52 96 L 40 69 L 10 72 L 32 52 L 17 24 L 44 38 Z',
  vampire: 'M 52 90 C 20 63 16 38 35 27 C 45 21 52 29 52 29 C 52 29 59 21 69 27 C 88 38 84 63 52 90 Z M 42 42 L 47 58 L 38 58 M 62 42 L 57 58 L 66 58',
  regen: 'M 53 17 C 73 18 88 37 80 58 C 73 76 53 83 35 73 L 27 83 L 22 50 L 52 58 L 42 66 C 55 71 69 64 72 51 C 76 35 65 24 53 22 Z',
  barrier: 'M 52 13 L 85 27 L 80 58 C 77 75 66 86 52 93 C 38 86 27 75 24 58 L 19 27 Z M 52 30 L 52 76 M 35 45 L 69 45',
  explode: 'M 52 15 L 59 39 L 84 29 L 71 52 L 93 63 L 68 68 L 73 92 L 52 76 L 31 92 L 36 68 L 11 63 L 33 52 L 20 29 L 45 39 Z',
  freeze: 'M 52 17 L 52 87 M 29 30 L 75 74 M 75 30 L 29 74 M 32 52 L 72 52',
  critChance: 'M 52 13 L 63 40 L 92 42 L 70 60 L 77 89 L 52 73 L 27 89 L 34 60 L 12 42 L 41 40 Z M 52 32 L 52 59 M 52 68 L 52 72',
  bulletSpeed: 'M 14 52 L 76 20 L 65 44 L 91 44 L 30 86 L 42 61 Z',
  blackHole: 'M 52 13 A 39 39 0 1 1 51 13 M 52 28 C 72 33 73 58 55 69 C 35 82 17 59 32 40 C 41 29 51 30 60 37',
  bladeAura: 'M 52 19 A 33 33 0 1 1 51 19 M 52 31 L 62 52 L 52 73 L 42 52 Z M 21 52 L 42 42 L 63 52 L 42 62 Z M 83 52 L 62 42 L 41 52 L 62 62 Z',
  meteorRain: 'M 22 24 L 68 70 M 37 13 L 84 60 M 51 8 L 93 50 M 24 73 L 43 92 L 53 67 Z M 48 66 L 68 88 L 77 60 Z',
  shockWeb: 'M 24 24 L 52 52 L 80 24 M 24 80 L 52 52 L 80 80 M 31 32 L 73 73 M 73 32 L 31 73 M 18 52 L 86 52',
};

export function upgradeArt(choice = {}) {
  const colors = palette[choice.rarity] || palette.common;
  const path = glyphs[choice.id] || glyphs.damage;
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104">
      <defs>
        <radialGradient id="g" cx="40%" cy="28%" r="70%">
          <stop offset="0" stop-color="${colors[0]}" stop-opacity=".95"/>
          <stop offset=".42" stop-color="${colors[1]}" stop-opacity=".62"/>
          <stop offset="1" stop-color="${colors[2]}" stop-opacity="1"/>
        </radialGradient>
        <filter id="glow"><feGaussianBlur stdDeviation="3.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
      </defs>
      <rect width="104" height="104" rx="18" fill="${colors[2]}"/>
      <path d="M0 74 C22 54 38 86 64 60 C82 42 91 45 104 30 L104 104 L0 104 Z" fill="url(#g)" opacity=".58"/>
      <circle cx="78" cy="24" r="18" fill="${colors[0]}" opacity=".12"/>
      <path d="${path}" fill="${colors[0]}" filter="url(#glow)"/>
      <path d="${path}" fill="none" stroke="#fff" stroke-opacity=".5" stroke-width="2"/>
    </svg>
  `;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
}

export function upgradeCardArt(choice = {}) {
  return 'url("/ui/upgrade-card-atlas.png")';
}

export function upgradeCardPosition(choice = {}) {
  if (choice.rarity === 'legendary') return '100% 50%';
  if (choice.rarity === 'epic') return '66.666% 50%';
  if (choice.rarity === 'rare') return '33.333% 50%';
  return '0% 50%';
}
